<template>
  <v-card
    rounded="10"
    @click="navigateToPod"
    @keydown.enter.prevent="navigateToPod"
    @keydown.space.prevent="navigateToPod"
    role="link"
    tabindex="0"
    elevation="0"
  >
    <v-card-text>
      <v-row>
        <v-col cols="4" sm="3" class="d-flex align-center justify-center">
          <div style="width: 148px; height: 80px;">
            <PodThumbnail :item="pod" compact />
          </div>

        </v-col>

        <v-col cols="4" sm="5" class="d-flex align-center">
          <div>
            <div class="item-title">
              {{ pod.name }}
            </div>
            <div v-if="rawAsset.duration">
              Duration: {{ videoDuration(parseFloat(rawAsset.duration || 0)) }}
            </div>
          </div>
        </v-col>

        <v-col cols="4" sm="3" class="d-flex align-center">
          <div>
            <div v-if="rawAsset.filetype">
              Type: {{ rawAsset.filetype }}
            </div>

            <div>
              Updated at: {{ isoToDate(pod.updatedat) }}
            </div>
          </div>
        </v-col>
      </v-row>

    </v-card-text>
  </v-card>
</template>

<script>
import PodThumbnail from '@/layouts2/components/PodThumbnail.vue';
import { isoToDate, videoDuration } from '@/components/formatters.js';

export default {
  name: 'AccesslinkListPodItem',
  methods: {
    isoToDate,
    videoDuration,
    navigateToPod() {
      this.$router.push({
        name: 'accesslink:view:pod',
        params: { podid: this.pod.id, nodeid: this.currentNodeId },
      });
    },
  },
  components: { PodThumbnail },
  props: {
    pod: {
      type: Object,
      required: true,
    },
    code: {
      type: String,
      required: true,
    },
    currentNodeId: {
      type: String,
      required: false,
    },
  },
  computed: {
    rawAsset: function() {
      if (this.pod && this.pod.asset && this.pod.asset.raw && this.pod.asset.raw[0]) {
        return this.pod.asset.raw[0];
      }
      return {};
    },
  }
}
</script>

<style lang="scss" scoped>
.item-title {
  font-weight: bolder;
  word-break: break-all;
}
</style>
